import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiTagsPanelComponent } from './ai-tags-panel.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AiTagsPanelComponent],
  exports: [AiTagsPanelComponent],
})
export class AiTagsPanelModule {}
